import { FormikProps } from 'formik';
import { Dispatch } from 'redux';
import Cleave from 'cleave.js/react';
import { Button, Col, Label, Row } from 'reactstrap';
import { GroupPrice } from 'types/MerchantTypes';
import { unitPriceFields } from 'pages/Products/ProductConstants';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { PricesFormType } from './PricesTypes';
import { useTranslation } from 'react-i18next';
import { EditPriceForm } from 'types/productTypes';
import {
  setCountPriceSubmit,
  setPriceFormErrorCount,
  setShowAllValidatePriceErrors,
} from 'slices/product/form/reducer';
import { useEffect } from 'react';

const PricesForm = ({
  dispatch,
  formik,
}: {
  dispatch: Dispatch;
  formik: FormikProps<EditPriceForm>;
}) => {
  const { t } = useTranslation();
  const infoState = useSelector((state: RootState) => state.Info);
  const { branchCodes } = infoState;
  const productFormState = useSelector((state: RootState) => state.Product);
  const { pageConfig, PriceModal } = productFormState.form;

  useEffect(() => {
    dispatch(setPriceFormErrorCount(Object.keys(formik.errors).length));
  }, [formik.errors, dispatch]);
  // console.log(formik.values);
  // console.log(formik.errors);
  // console.log(formik.errors.cost_price);
  return (
    <>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Branch')} <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={6} className="d-flex align-items-center">
          <div>
            <span>
              {t('Branch')}{' '}
              {
                branchCodes.find(
                  (b) => b.storeId === parseInt(formik.values.store_id, 10)
                )?.code
              }
            </span>
          </div>
        </Col>
      </div>
      <div className="mb-3 row">
        <Label htmlFor={`cost_price`} className="col-sm-4 col-form-label">
          {t('ProductField_CostPrice')} <span style={{ color: 'red' }}>*</span>
        </Label>

        <Col sm={6} xs={12}>
          <Cleave
            className={`form-control`}
            name={`cost_price`}
            value={formik.values.cost_price || ''}
            options={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralThousandsGroupStyle: 'thousand',
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.cost_price && formik.errors.cost_price ? (
            <div className="text-danger">{formik.errors.cost_price}</div>
          ) : null}
        </Col>
      </div>
      {unitPriceFields.map((unitPriceField) => {
        // const priceObj: GroupPrice | undefined =
        //   productFormDetails.pageConfig.group_price.find(
        //     (item) => item.id === unitPriceField.id
        //   );
        const priceObj: GroupPrice | undefined =
          pageConfig?.group_price?.find?.(
            (item) => item.id === unitPriceField.id
          );
        const displayStyle = priceObj ? {} : { display: 'none' };

        return (
          <div
            className="mb-3 row"
            key={unitPriceField.id}
            style={displayStyle}
          >
            <Label
              htmlFor={`${unitPriceField.fieldName}_value`}
              className="col-sm-4 col-form-label"
            >
              {priceObj ? (
                unitPriceField.id === 0 ? (
                  <>
                    {priceObj.name} <span style={{ color: 'red' }}>*</span>
                  </>
                ) : (
                  priceObj.name
                )
              ) : (
                ''
              )}
            </Label>

            <Col sm={6} xs={12}>
              <Cleave
                className={`form-control`}
                name={`${unitPriceField.fieldName}`}
                value={
                  formik.values[
                    unitPriceField.fieldName as keyof PricesFormType
                  ] || ''
                }
                options={{
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralThousandsGroupStyle: 'thousand',
                }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {((formik.touched[
                unitPriceField.fieldName as keyof PricesFormType
              ] as any) &&
                (formik.errors[
                  unitPriceField.fieldName as keyof PricesFormType
                ] as any) &&
                (typeof formik.errors[
                  unitPriceField.fieldName as keyof PricesFormType
                ] as any) === 'string') ||
              (formik.isValid === false &&
                formik.errors[
                  unitPriceField.fieldName as keyof PricesFormType
                ] &&
                PriceModal.showAllValidateErrors === true) ? (
                <div className="text-danger">
                  {
                    formik.errors[
                      unitPriceField.fieldName as keyof PricesFormType
                    ] as any
                  }
                </div>
              ) : null}
            </Col>

            <Col sm={3} xs={4}>
              {/* <div
                      className={`form-check ${
                        isEdit ? '' : styles['check-box-hide']
                      }`}
                    >
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id={`${unitPriceField.fieldName}_apply_all`}
                        name={`${unitPriceField.fieldName}.apply_all`}
                        checked={
                          typeof formik.values[
                            unitPriceField.fieldName as keyof ProductFormDetailsInterface
                          ] === 'object' &&
                          (
                            formik.values[
                              unitPriceField.fieldName as keyof ProductFormDetailsInterface
                            ] as any
                          ).apply_all === 1
                        }
                        onChange={(e) => {
                          const fieldValue =
                            formik.values[
                              unitPriceField.fieldName as keyof ProductFormDetailsInterface
                            ];
                          if (
                            typeof fieldValue === 'object' &&
                            fieldValue !== null
                          ) {
                            formik.setFieldValue(unitPriceField.fieldName, {
                              ...fieldValue,
                              apply_all: e.target.checked ? 1 : 0,
                            });
                          }
                        }}
                      />
                      <Label
                        className="form-check-label"
                        htmlFor={`${unitPriceField.fieldName}_apply_all`}
                      >
                        {t('ProductField_EditAllBranch')}
                      </Label>
                    </div> */}
            </Col>
          </div>
        );
      })}
      <Row>
        <Col xs={12} sm={12} className="text-center">
          <div className="mb-3">
            <Row>
              <Col xs={0} sm={4}></Col>

              <Col xs={5} sm={3}>
                <Button
                  block
                  color="success"
                  type="submit"
                  id="edit-price-save"
                  disabled={
                    PriceModal.FormErrorCount !== 0 || formik.isSubmitting
                  }
                  // disabled={formik.isSubmitting}
                  onClick={async () => {
                    await formik.setTouched(
                      Object.keys(formik.initialValues).reduce(
                        (acc, key) => ({ ...acc, [key]: true }),
                        {}
                      )
                    );
                    dispatch(setShowAllValidatePriceErrors(true));
                    dispatch(setCountPriceSubmit());
                  }}
                >
                  {t('Btn_Save')}
                </Button>
              </Col>
              {/* <Col xs={1} sm={3}></Col> */}
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PricesForm;
